/**
 * Employee display-name helpers.
 *
 * Arabic documents (letters, Arabic crew lists) must show the Arabic name,
 * English documents the English name — each falling back to the other when
 * one is missing.
 */

interface NamedEmployee {
  name?: string;
  arabicName?: string;
}

export const arabicEmployeeName = (employee?: NamedEmployee | null): string =>
  employee ? employee.arabicName || employee.name || '' : '';

export const englishEmployeeName = (employee?: NamedEmployee | null): string =>
  employee ? employee.name || employee.arabicName || '' : '';

interface PositionedEmployee {
  /** English rank name, e.g. "Master" */
  rank?: string;
  /** Arabic job title, e.g. "ربان" */
  position?: string;
}

/** English contexts show the rank; Arabic contexts the Arabic position —
 *  each falling back to the other when one is missing. */
export const positionForLanguage = (
  employee: PositionedEmployee | null | undefined,
  language: 'ar' | 'en'
): string => {
  if (!employee) return '';
  return language === 'en'
    ? employee.rank || employee.position || ''
    : employee.position || employee.rank || '';
};
